<template>
    Project List
</template>

<script>
export default {
  name: "Home",
  setup() {
  }
};
</script>